import { onMounted, ref } from 'vue'
import { useIdentity } from './identity/index.js'

export const useAccount = () => {
  const { identity } = useIdentity()
  const isLoggedIn = ref(false)

  const initIdentity = async () => {
    window.Identity = identity
    try {
      const alreadyLoggedIn = await identity.isLoggedIn()
      if (alreadyLoggedIn) {
        const sess = await identity.hasSession()

        if (sess.clientAgreementAccepted && sess.defaultAgreementAccepted) {
          isLoggedIn.value = true
          window.psi.setUserId(sess.userId)
        }
      }
    } catch (e) {
      console.error(e)
    }
  }

  onMounted(async () => {
    await initIdentity()
  })

  const base64UrlEncode = (obj) => encodeURI(btoa(JSON.stringify(obj)))

  const login = async () => {
    // todo verify state
    const state = {
      redirectUri: document.location.href,
      state: Math.random().toString(32),
    }
    await identity.login({
      state: base64UrlEncode(state),
    })
  }

  const logout = async () => {
    await identity.logout(document.location.origin)
  }

  return {
    isLoggedIn,
    login,
    logout,
  }
}
